// Pricing module routes. Focused IA (2026-05-25): three surfaces only —
//   /pricing                 — Unit Rate Catalogue (tariff browser + EFL)
//   /pricing/rates-overview  — Rates Overview (read; 3-section rate stack)
//   /pricing/config          — Pricing Config (write; 4 admin CRUDs as tabs)
//
// The former standalone pages (Unit Rate Builder, Wholesale Viewer) and the
// per-resource admin routes were retired from navigation; the admin screens
// now live as tabs inside PricingConfigPage. The Builder/Wholesale page files
// are kept dormant (not routed) for easy restore.

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const UnitRatePage = lazy(() =>
  import('./pages/UnitRatePage').then((m) => ({ default: m.UnitRatePage })),
);
const RatesOverviewPage = lazy(() =>
  import('./pages/RatesOverviewPage').then((m) => ({ default: m.RatesOverviewPage })),
);
const PricingConfigPage = lazy(() =>
  import('./pages/PricingConfigPage').then((m) => ({ default: m.PricingConfigPage })),
);
// Tariffs has its OWN route as well as its tab inside Pricing Config. It is the
// only page in that group an operator uses as a daily task — creating and
// editing the plans the quote flow sells — and reaching it meant knowing to
// open "Pricing Config" and finding the fourth tab. The tab stays so existing
// deep links (`/pricing/config?tab=tariffs`) keep working.
const TariffsAdminPage = lazy(() =>
  import('./pages/TariffsAdminPage').then((m) => ({ default: m.TariffsAdminPage })),
);

export const pricingRoutes: RouteObject[] = [
  { path: '/pricing', element: <UnitRatePage /> },
  { path: '/pricing/rates-overview', element: <RatesOverviewPage /> },
  { path: '/pricing/config', element: <PricingConfigPage /> },
  { path: '/pricing/tariffs', element: <TariffsAdminPage /> },
];
